(() => {
  const params = new URLSearchParams(window.location.search);

  if (params.get('cal_booking') !== 'confirmed' || !Array.isArray(window.dataLayer)) return;

  window.dataLayer.push({
    event: 'cal_booking_confirmation_page',
    booking_status: 'confirmed'
  });
})();
